import FormCheckbox from "./FormCheckbox";
import { SelectDropdown, VASPListDropdown } from "../common/SelectDropdown";
import { FormInput } from "../common/FormInput";
// import DateSelectorInput from "../common/DateSelectorInput";
import useAllCountries from "../../../hooks/useAllCountries";
import CountriesDropdown from "../common/CountriesDropdown";


const TravelRuleInputs = ({ 
  vaspOptions,
  declareWallet,
  selectedVASP,
  beneficiaryType,
  beneficiaryFirstName,
  beneficiaryLastName,
  businessLegalName,
  dob,
  countryCode,
  beneficiaryVASPName,
  walletType,
  sendToMyself,
  VASPNotInList,
  setError
 }) => {
  const allCountries = useAllCountries();
  // const [selectedNationality, setSelectedNationality] = useState("");
  return (
    <div className="space-y-6 pt-4">
      <hr className="w-full border-divider" />

      {/* --- Section 1: Header & Self-Transfer Declaration --- */}
        <h3 className="text-base font-semibold text-text-primary">
          Beneficiary Information
        </h3>
      <div className="rounded-xl border border-divider bg-background-surface/50 p-4 space-y-3">
        <div>
          <p className="text-xs text-text-secondary mt-0.5 leading-relaxed">
            Check the box below if this wallet belongs to your registered entity.
            The system will set the Beneficiary Type to <b>Business</b> automatically.
          </p>
        </div>

        <FormCheckbox
          id="send_to_myself"
          checked={sendToMyself.value}
          onChange={(isChecked) => {
            sendToMyself.setValue(isChecked);
            sendToMyself.setError("");

            if (isChecked) {
              beneficiaryType.setValue("BUSINESS");
              beneficiaryType.setError("");
              beneficiaryFirstName.setValue("");
              beneficiaryLastName.setValue("");
              businessLegalName.setValue("");
            } else {
              beneficiaryType.setValue("");
              businessLegalName.setValue("");
            }
          }}
          label="Sending to myself"
        />
      </div>

      {/* --- Section 2: Beneficiary Details --- */}
      <div className="flex flex-col gap-2">
        {/* Animated Beneficiary Type Dropdown */}
        <div
          className={`grid transition-all duration-300 ease-in-out ${
            !sendToMyself.value
              ? "grid-rows-[1fr] opacity-100"
              : "grid-rows-[0fr] opacity-0 pointer-events-none"
          }`}
        >
          {/* Changed overflow-hidden to conditionally be overflow-visible when expanded */}
          <div className={!sendToMyself.value ? "overflow-visible" : "overflow-hidden"}>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
              <SelectDropdown
                label="Beneficiary Type"
                placeholder="Select beneficiary type"
                options={[
                  { label: "Individual", value: "INDIVIDUAL" },
                  { label: "Business", value: "BUSINESS" },
                ]}
                value={beneficiaryType.value}
                error={beneficiaryType.error}
                onChange={(val) => {
                  beneficiaryType.setValue(val);
                  beneficiaryType.setError("");
                  beneficiaryFirstName.setValue("");
                  beneficiaryLastName.setValue("");
                  businessLegalName.setValue("");
                  declareWallet.setValue(false);
                }}
              />
            </div>
          </div>
        </div>

        {/* Animated Business Name Input */}
        <div
          className={`grid transition-all duration-300 ease-in-out ${
            beneficiaryType.value === "BUSINESS" && !sendToMyself.value
              ? "grid-rows-[1fr] opacity-100"
              : "grid-rows-[0fr] opacity-0 pointer-events-none"
          }`}
        >
          <div className="overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 pt-1">
              <FormInput
                id="beneficiary_legal_name"
                label="Beneficiary Legal Name"
                type="text"
                placeholder="Enter business legal name"
                {...businessLegalName}
              />
            </div>
          </div>
        </div>

        {/* Animated Individual First / Last Name */}
        <div
          className={`grid transition-all duration-300 ease-in-out gap-3 ${
            beneficiaryType.value === "INDIVIDUAL" && !sendToMyself.value
              ? "grid-rows-[1fr] opacity-100 block"
              : "grid-rows-[0fr] opacity-0 pointer-events-none hidden"
          }`}
        >
          <div className="overflow-hidden grid grid-cols-1 md:grid-cols-2 gap-4 pt-3">
            <FormInput
              id="first_name"
              label="First Name"
              type="text"
              placeholder="Enter first name"
              {...beneficiaryFirstName}
            />
            <FormInput
              id="last_name"
              label="Last Name"
              type="text"
              placeholder="Enter last name"
              {...beneficiaryLastName}
            />
          </div>

          {/* <DateSelectorInput
            text="Select date of birth"
            name="dob"
            id="dob"
            placeholder="Select date of birth"
            onChange={dob.onChange}
            selectedDate={dob.value}
            disableFutureDates={true}
            scrollInModal={true}
            setError={setError}
          /> */}

        </div>

        <CountriesDropdown
          label={"Country code"}
          value={countryCode?.value}
          onChange={(country) => {
            countryCode.setValue(country)
          }}
          options={allCountries}
          placeholder={"Choose your country code."}
          searchPlaceholder={"Search country.."}
          // loading={}
          // disabled={}
          // error={}
          // className={}
        />
      </div>

      {/* --- Section 3: Wallet & VASP Information --- */}
      <div className="space-y-4 pt-2 border-t border-divider">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-2">
          {/* Wallet Type */}
          <div className="space-y-1">
            <SelectDropdown
              label="Wallet Type"
              placeholder="Select wallet type"
              options={[
                {
                  label: "Custodial (Exchange / Third-party)",
                  value: "CUSTODIAL",
                },
                {
                  label: "Self-Hosted (MetaMask, Ledger, etc.)",
                  value: "SELF_HOSTED",
                },
              ]}
              value={walletType.value}
              error={walletType.error}
              onChange={(val) => {
                walletType.setValue(val);
                walletType.setError("");
                selectedVASP.setValue("");
                // declareWallet.setValue(false);
              }}
            />
            <p className="text-[11px] text-text-secondary leading-normal">
              <b>Custodial:</b> Exchange managed (Binance, Coinbase). <br />
              <b>Self-Hosted:</b> Directly controlled by user (Hardware/Web3).
            </p>
          </div>

          {/* Animated VASP Selection (Only if Custodial) */}
          <div
            className={`grid transition-all duration-300 ease-in-out ${
              walletType.value === "CUSTODIAL"
                ? "grid-rows-[1fr] opacity-100"
                : "grid-rows-[0fr] opacity-0 pointer-events-none"
            }`}
          >
            {/* Changed overflow-hidden to conditionally be overflow-visible when expanded */}
            <div className={`space-y-2 ${walletType.value === "CUSTODIAL" ? "overflow-visible" : "overflow-hidden"}`}>
              <div className="relative w-full">
                {/* Option A: Dropdown View */}
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    !VASPNotInList.value
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0 pointer-events-none"
                  }`}
                >
                  <div className={!VASPNotInList.value ? "overflow-visible" : "overflow-hidden"}>
                    <VASPListDropdown
                      label="Beneficiary VASP (Exchange)"
                      placeholder="Select exchange / VASP"
                      searchPlaceholder="Search exchange..."
                      options={vaspOptions}
                      loading={!vaspOptions}
                      value={selectedVASP.value}
                      error={selectedVASP.error}
                      onChange={(option) => {
                        selectedVASP.setValue(option);
                        selectedVASP.setError("");
                      }}
                    />
                  </div>
                </div>

                {/* Option B: Manual Input View */}
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    VASPNotInList.value
                      ? "grid-rows-[1fr] opacity-100 mt-2"
                      : "grid-rows-[0fr] opacity-0 pointer-events-none"
                  }`}
                >
                  <div className="overflow-hidden">
                    <FormInput
                      id="beneficiary_vasp_manual"
                      label="Beneficiary VASP Name"
                      placeholder="Enter exchange name manually"
                      type="text"
                      {...beneficiaryVASPName}
                    />
                  </div>
                </div>
              </div>

              <div className="pt-0.5">
                <div 
                  className={`rounded-lg border border-divider bg-background-alt/40 p-3.5 mt-2 ${
                    VASPNotInList.error && "border-red-500 bg-error-500/10"}
                  `}
                >
                  <FormCheckbox
                    checked={VASPNotInList.value}
                    onChange={(isChecked) => {
                      VASPNotInList.setValue(isChecked);
                      selectedVASP.setValue("");
                      beneficiaryVASPName.setValue("");
                    }}
                    label="Exchange is not in the list"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Animated Self-Hosted Ownership Declaration */}
        <div
          className={`grid transition-all duration-300 ease-in-out ${
            // walletType.value === "SELF_HOSTED"
            sendToMyself.value
              ? "grid-rows-[1fr] opacity-100"
              : "grid-rows-[0fr] opacity-0 pointer-events-none"
          }`}
        >
          <div className="overflow-hidden">
            <div className={`rounded-lg border border-divider bg-background-alt/40 p-3.5 mt-2 ${
              declareWallet.error && "border-red-500 bg-error-500/10"}
            `}>
              <FormCheckbox
                checked={declareWallet.value}
                onChange={(isChecked) => {
                  declareWallet.setValue(isChecked);
                  declareWallet.setError("");
                }}
                label="I declare that I own and control this self-hosted wallet"
                error={declareWallet.error}
              />
            </div>
          </div>
        </div>
      </div>

      <hr className="w-full border-divider" />
    </div>
  );
};

export default TravelRuleInputs;